"use client";
// Imports
import { Icon } from "@/components";
import { formatEventTimeLabel, formatShowCalendarDayLabel } from "@/lib/showDates";

export function EventTimesList({ collectionHandle, eventTimes }) {
  if (collectionHandle !== "events") return null;
  function getDate(value) {
    return formatShowCalendarDayLabel(value);
  }

  function getTime(time) {
    return formatEventTimeLabel(time, { empty: "" });
  }

  let uniqueDates = [];
  // Remove duplicate dates from eventTimes.date
  eventTimes.forEach((event) => {
    // Add the event to the uniqueDates array if it doesn't already exist but
    if (!uniqueDates.find((date) => date.date === event.date)) {
      uniqueDates.push({ date: event.date, times: [event?.start_time] });
    } else {
      // If it does exist, add the start_time to the times array
      uniqueDates
        .find((date) => date.date === event.date)
        .times.push(event?.start_time);
    }
  });

  return (
    <div className="">
      {uniqueDates.length > 0 &&
        uniqueDates.map((event, index) => {
          const times = event?.times
            ?.map((time) => getTime(time))
            .filter(Boolean);
          // Dedupe identical labels (e.g. multiple 9:00 AM rings)
          const uniqueTimes = [...new Set(times)];

          return (
            <div
              key={index}
              className="flex flex-col items-start justify-start py-2 space-y-1 border-b"
            >
              <div className="flex space-x-2">
                <Icon icon="events" size={20} strokeWidth={1.7} />
                <p>{getDate(event?.date)}</p>
              </div>
              {uniqueTimes.length > 0 && (
                <div className="flex space-x-2">
                  <div>
                    <Icon icon="clock" size={20} />
                  </div>
                  <div className="flex flex-wrap gap-x-1">
                    {uniqueTimes.map((time, timeIndex) => (
                      <p key={timeIndex}>
                        {time}
                        {timeIndex < uniqueTimes.length - 1 && <span>,</span>}
                      </p>
                    ))}
                  </div>
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
}
